// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__347RY","label":"Category_label__3vOgB","content":"Category_content__3Fgve","header":"Category_header__3QVe3","location":"Category_location__3O8Iw"};